const serbianMap = {
  š: "s",
  ć: "c",
  č: "c",
  ž: "z",
  đ: "dj",
};

export const replaceCharacters = (
  path,
  toBeChanged = " ",
  toChangeWith = "_",
  makeCapitalize = false,
) => {
  let value = path
    ?.toString()
    ?.toLowerCase()
    .replaceAll(toBeChanged, toChangeWith)
    .replaceAll("-", "")
    .replaceAll("_", "")
    .replace(/š|ć|č|ž|đ/gi, function (found) {
      return serbianMap[found];
    });
  if (value && makeCapitalize) {
    let words = value.split(" ");
    for (let i = 0; i < words.length; i++) {
      words[i] =
        words[i][0] !== undefined
          ? (!["-", "_", " "].includes(words[i][0])
              ? words[i][0].toUpperCase()
              : words[i][0]) + words[i].substr(1)
          : "";
    }
    return words.join(" ");
  }
  return value;
};
export const mapPropertyType = (type, isSingle = false) => {
  let retVal = "";
  switch (type) {
    case "kuca":
      retVal = "prodaja-kuca";
      break;
    case "stan":
      retVal = isSingle ? "prodaja-stan" : "prodaja-stanova";
      break;
    case "lokal":
      retVal = isSingle ? "prodaja-lokal" : "prodaja-lokala";
      break;
    case "plac":
      retVal = isSingle ? "prodaja-plac" : "placevi-na-prodaju";
      break;
    case "garaza":
      retVal = "prodaja-garaza";
      break;
    default:
      break;
  }

  return retVal;
};

export const getPropertyUrl = (property) => {
  const base = import.meta.env.VITE_APP_FRONTEND_APP_LINK;
  const type = mapPropertyType(property?.type);
  const city = replaceCharacters(property?.city?.name);
  const area = property?.area ? `-${replaceCharacters(property?.area)}` : "";
  const url = `${base}/${type}/${city}${area}/${property?.property_code}`;
  return url;
};
